function parseQuery(str = window.location.search) {
  const qs = str.indexOf('?') === -1 ? str : str.split('?')[1];
  if (qs.length > 0) {
    let s;
    const q = {};
    let arr = [];
    arr = qs.split('&');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i]) {
        // eslint-disable-next-line no-continue
        continue;
      }
      s = arr[i].split('=');
      // eslint-disable-next-line prefer-destructuring
      q[s[0]] = s[1];
    }
    return q;
  }
  return {};
}

function delayWrap(execNow, options = {}) {
  if (typeof execNow === 'function') {
    const list = [];
    execNow(() => {
      list.forEach((fn) => fn());
      if (options.once) {
        list.length = 0;
      }
    });
    return function regist(fn) {
      if (typeof fn === 'function') {
        list.push(fn);
      }
    };
  }
  throw new Error('delayWrap的参数必须是函数');
}

// 获取浏览器类型
function getBrowserType() {
  // 获取浏览器 userAgent
  const ua = navigator.userAgent;
  // 是否为 Opera
  const isOpera = ua.indexOf('Opera') > -1;
  // 返回结果
  if (isOpera) { return 'Opera'; }

  // 是否为 IE
  const isIE = (ua.indexOf('compatible') > -1) && (ua.indexOf('MSIE') > -1) && !isOpera;
  const isIE11 = (ua.indexOf('Trident') > -1) && (ua.indexOf('rv:11.0') > -1);
  // 返回结果
  if (isIE11) {
    return 'IE11';
  } if (isIE) {
    // 检测是否匹配
    // eslint-disable-next-line prefer-regex-literals
    const re = new RegExp('MSIE (\\d+\\.\\d+);');
    re.test(ua);
    // 获取版本
    const ver = parseFloat(RegExp.$1);
    // 返回结果
    if (+ver === 7) {
      return 'IE7';
    } if (+ver === 8) {
      return 'IE8';
    } if (+ver === 9) {
      return 'IE9';
    } if (+ver === 10) {
      return 'IE10';
    } return 'IE';
  }

  // 是否为 Edge
  const isEdge = ua.indexOf('Edge') > -1;
  // 返回结果
  if (isEdge) { return 'Edge'; }

  // 是否为 Firefox
  const isFirefox = ua.indexOf('Firefox') > -1;
  // 返回结果
  if (isFirefox) { return 'Firefox'; }

  // 是否为 Safari
  const isSafari = (ua.indexOf('Safari') > -1) && (ua.indexOf('Chrome') === -1);
  // 返回结果
  if (isSafari) { return 'Safari'; }

  // 是否为 Chrome
  const isChrome = (ua.indexOf('Chrome') > -1) && (ua.indexOf('Safari') > -1) && (ua.indexOf('Edge') === -1);
  // 返回结果
  if (isChrome) { return 'Chrome'; }

  // 是否为 UC
  const isUC = ua.indexOf('UBrowser') > -1;
  // 返回结果
  if (isUC) { return 'UC'; }

  // 是否为 QQ
  const isQQ = ua.indexOf('QQBrowser') > -1;
  // 返回结果
  if (isQQ) { return 'QQ'; }

  // 都不是
  return '';
}

// 将一个数格式化成指定位数小数，在比较数值是否相等时可以用用
function formatFloat(f, digit) {
  // const m = Math.pow(10, digit);
  const m = 10 ** digit;
  return parseInt(Math.round(f * m), 10) / m;
}

// 物品商品名称格式化
export function getGoodsShowName(name, type, priceName) {
  let str = name;
  // 按物品定价
  if (type === 2) {
    str += `(${priceName})`;
  }
  return str;
}

export default {
  parseQuery,
  delayWrap,
  getBrowserType,
  formatFloat,
  getGoodsShowName,
};
